import React from 'react'
import PropTypes from 'prop-types'
import Media from 'react-media'
import { Tooltip } from 'react-tippy'
import { withAppContext } from '../utils/AppContext'

import Icon from './Icon'

import styles from '../scss/ui/header.scss'
import style from '../scss/layout/app.scss'
import SocialShareButton from './SocialShareButton'
import wicLogo from '../images/WiC_Logo_black.png'

const Header = ({ appContext }) => (
    <header>
        <a
            href="https://winteriscoming.net"
            rel="noopener noreferrer"
            target="_blank"
            className={styles.backLink}>
            <img src={wicLogo} alt="Winter is Coming Logo" />
        </a>
        <Media query="(min-width: 415px)">
            {// eslint-disable-next-line
                matches => matches ?
                    // ( <button className={styles.headerResetButton} onClick={appContext.reset}
                    (
                        <div>
                            <button className={styles.headerResetButton} onClick={appContext.reset} type="button">
                                <Tooltip
                                    hideOnClick={false}
                                    title="Reset Defaults"
                                    position="bottom"
                                    trigger="mouseenter"
                                    arrow="true">
                                    <Icon icon="reset" size={3} color="lighter" className={style.icons} />
                                </Tooltip>
                            </button>
                            <SocialShareButton
                                onClick={() => appContext.toggleShareLightboxOn()}
                                iconSize={3}
                                color="lighter"
                                className={styles.headerShareButton}
                            />
                        </div>
                    ) : (
                        <div>
                            <button className={styles.headerResetButton} onClick={appContext.reset} type="button">
                                <Icon icon="reset" size={2} color="lighter" className={style.icons} />
                            </button>
                            <SocialShareButton
                                onClick={() => appContext.toggleShareLightboxOn()}
                                iconSize={2}
                                color="lighter"
                                className={styles.headerShareButton}
                            />
                        </div>
                    )
            }
        </Media>
    </header>
)

Header.propTypes = {
    appContext: PropTypes.object.isRequired,
}

export default withAppContext(Header)



// WEBPACK FOOTER //
// ./src/ui/Header.js